@let userValue = user.value();

@if (userValue) {
  <div class="p-6">

    <h1 class="font-bold text-3xl">{{ userValue.id }}
      <p-tag [severity]="homeyStatusToTag(userValue.status)">{{ userValue.status }}</p-tag>
      @if (userValue.ignore) {
        <p-tag [severity]="'danger'">IGNORED</p-tag>
      }
    </h1>
    <div class="flex flex-row justify-between">
      <div class="max-w-2xl">
        <p class="text-sm text-muted-color mb-6">Created at {{ userValue.createdAt | date: 'dd-MM-yyyy HH:mm:ss' }}</p>

        <div class="grid grid-cols-2 gap-y-6">
          <app-labeled label="First name" [value]="userValue.firstName"/>
          <app-labeled label="Last name" [value]="userValue.lastName"></app-labeled>

          <app-labeled label="Subscription status" [value]="userValue.subscription?.status"
                       [tagFunction]="subscriptionStatusToTag"></app-labeled>
          <app-labeled label="User app access" [value]="userValue.subscription?.paymentStatus"
                       [tagFunction]="paymentStatusToTag"></app-labeled>

          <app-labeled label="Last seen"
                       [value]="userValue.lastSeen | date: 'dd-MM-yyyy HH:mm:ss'"></app-labeled>
          <app-labeled label="Trialing" [value]="userValue.trialing ? 'Yes' : 'No'"></app-labeled>

          <app-labeled label="Email" [value]="userValue.email"></app-labeled>
          <app-labeled label="Phone" [value]="userValue.phone"></app-labeled>

          <app-labeled label="Household size" [value]="userValue.nycProfile?.householdSize"></app-labeled>
          <app-labeled label="Rental assistance" [value]="userValue.rentalAssistance ? 'Yes' : 'No'"></app-labeled>
          <app-labeled label="Birth date" [value]="userValue?.birthDate"></app-labeled>

          <app-labeled label="Subscription type" [value]="userValue.subscription?.type"></app-labeled>
          <app-labeled label="Referring source" [value]="userValue.source"/>
          <app-labeled label="NYC Profile Status" [value]="userValue.nycProfile?.status"
                       [tagFunction]="nycProfileStatusToTag"></app-labeled>
          <app-labeled label="NYC Sync Status" [value]="userValue.nycProfile?.syncStatus"
                       [tagFunction]="syncStatusToTag"></app-labeled>
          <app-labeled label="Current NYC Profile Status"
                       [value]="userValue.nycProfile?.currentNycProfileStatus"></app-labeled>
          <app-labeled label="Current NYC Login Status" [value]="userValue.nycProfile?.loginStatus"></app-labeled>
          <app-labeled label="Last synced at"
                       [value]="userValue.nycProfile?.lastSyncedAt | date: 'dd-MM-yyyy HH:mm:ss'"></app-labeled>
          <app-labeled label="Resync scheduled at"
                       [value]="userValue.nycProfile?.nextScheduledSyncAt | date: 'dd-MM-yyyy HH:mm:ss'"/>

          <app-labeled label="Last sync result" [value]="userValue.nycProfile?.lastScheduledSyncResult"/>
          <app-labeled label="Last sync error" [value]="userValue.nycProfile?.lastScheduledSyncError"/>

          <app-labeled label="NYC Email 1" [value]="userValue.nycProfile?.mail1"></app-labeled>
          <app-labeled label="NYC Email 2" [value]="userValue.nycProfile?.mail2"></app-labeled>
          <app-labeled label="NYC Username" [value]="userValue.nycProfile?.username"></app-labeled>
          <app-labeled label="NYC Password" [value]="userValue.nycProfile?.password" [copy]="true"></app-labeled>
        </div>
      </div>
      <div class="flex flex-col gap-2 mt-12">
        <p-button
          (onClick)="onRegisterInNYCClick()"
          label="Register in NYC"
          icon="pi pi-plus"
          [disabled]="!(userValue.nycProfile?.status === 'not-created' && userValue.status === 'active')"/>
        @if (userValue.nycProfile?.status === 'waiting-on-email2-verification') {
          <p-button
            (onClick)="unlockEmailTwo()"
            label="Unlock Email 2 State"
            icon="pi pi-mail"/>
        }
        @if (userValue.status === 'active') {
          <p-button
            (onClick)="onIgnoreToggle()"
            label="Toggle ignore"
            icon="pi pi-pencil"/>
        <p-button
          (onClick)="addMissingNycIds()"
          label="Resync missing nyc ids"
          icon="pi pi-send"/>
        <p-button
          (onClick)="triggerScheduledResync()"
          label="Trigger scheduled resync"
          icon="pi pi-refresh"/>
        @if (allowManualNycSync()) {
          <p-button
            (onClick)="syncUserWithNyc()"
            label="Manual NYC sync"
            icon="pi pi-sync"
            [loading]="syncingUserWithNyc()"
            [disabled]="syncingUserWithNyc()"/>
        }
        <p-button
          (onClick)="redistributeIncome()"
          label="Redistribute income"
          icon="pi pi-dollar"/>
          <p-button
            (onClick)="resetLoginSyncResult()"
            label="Resey login sync result"
            icon="pi pi-user"/>
          <p-button
            (onClick)="markCurrentProfileComplete()"
            label="Mark current profile status complete"
            icon="pi pi-refresh"/>
          <p-button
            (onClick)="allowResetPassword()"
            label="Mark resetting password"
            icon="pi pi-user"/>
          <p-button
            (onClick)="editNycAuth()"
            label="Edit NYC auth"
            icon="pi pi-lock"
            [disabled]="!(userValue.nycProfile?.status === 'not-created' || userValue.nycProfile?.status === 'complete')"/>
          <p-button
            (onClick)="linkAuthToOtherUser()"
            label="Link auth to other user"
            icon="pi pi-link"/>
          <p-button
            (onClick)="openHC()"
            label="Open HC"
            icon="pi pi-external-link"
            [disabled]="userValue.status !== 'active'"/>
          <p-button
            (onClick)="sendTextMessage()"
            label="Send text message"
            icon="pi pi-comment"
            [disabled]="!(userValue.smsNotificationsEnabled && userValue.phone)"/>
          @if (allowApplicationUpsert) {
            <p-button
              (onClick)="openApplicationCreatePage()"
              label="Add application"
              icon="pi pi-file-plus"/>
          }
        }
        @if (!userValue.subscription || userValue.subscription.paymentStatus === 'not-paid') {
          <p-button
            (onClick)="markAsPaid()"
            label="Mark as paid"
            icon="pi pi-dollar"/>
        }
        <p-button
          (onClick)="openNotificationTestPage()"
          label="Test notification"
          icon="pi pi-bell"/>
        <p-button
          (onClick)="resetFailedApplications()"
          label="Reset failed applications"
          icon="pi pi-refresh"
          [disabled]="!(userValue.nycProfile?.status !== 'not-created')"/>
        <p-button
          (onClick)="deleteUser()"
          label="Delete"
          severity="danger"
          icon="pi pi-trash"
        />
      </div>
    </div>


    <h2 class="mt-12 text-xl font-medium">Mails</h2>
    <p-table [value]="userValue.mails">
      <ng-template pTemplate="header">
        <tr>
          <th>Id</th>
          <th>Status</th>
          <th>Subject</th>
          <th>Timestamp</th>
          <th>Error message</th>
          <th>Download</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-email [cTypedTableRow]="userValue.mails">
        <tr>
          <td>{{ email.id }}</td>
          <td>
            <p-tag>{{ email.status }}</p-tag>
          </td>
          <td>{{ email.recipient }}</td>
          <td>{{ email.subject }}</td>
          <td>
            {{ email.timestamp | date: 'dd-MM-yyyy HH:mm:ss' }}
          </td>
          <td>
            @if (email.status !== 'processed') {
              <p-tag>{{ email.errorMessage }}</p-tag>
            }
          </td>
          <td>
            <p-button (onClick)="onEmailDownload(email.s3Key)">Download</p-button>
            <p-button (onClick)="retryEmail(email.s3Key)">Retry</p-button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="6" class="text-center">No emails found</td>
        </tr>
      </ng-template>
    </p-table>
    <h2 class="mt-12 text-xl font-medium">Applications</h2>
    <div class="mb-6 mt-2">
      <p-button class="mr-4" (onClick)="getEligibility()">Check eligibility for Apartment</p-button>
      <p-button (onClick)="addApartmentManually()">Add apartment from Housing Connect</p-button>
      @if (allowEligibleLotteryEvent) {
        <p-button
          class="ml-4"
          (onClick)="openEligibleEventDialog()"
          label="Emit eligible lottery event"
          icon="pi pi-bolt"></p-button>
      }
    </div>
    <p-table [value]="userValue.applications">
      <ng-template pTemplate="header">
        <tr>
          <th>Apartment Id</th>
          <th>Status</th>
          <th>Method</th>
          <th>Created At</th>
          <th>Log Nr</th>
          <th>Withdrawn</th>
          <th>Failure Reason</th>
          <th>Id</th>
          <th>Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-application [cTypedTableRow]="userValue.applications">
        <tr>
          <td>{{ application.lotteryId }}</td>
          <td>
            <p-tag [severity]="applicationStatusToTag(application.status)">{{ application.status }}</p-tag>
          </td>
          <td>{{ application.method }}</td>
          <td>{{ application.createdAt | date: 'dd-MM-yyyy HH:mm:ss' }}</td>
          <td>{{ application.logNr }}</td>
          <td>{{ application.withdrawnManually }}</td>
          <td>{{ application.failureReason }}</td>
          <td>{{ application.id }}</td>

          <td>
            <div class="flex flex-col gap-2">
              @if (application.status === 'not-synced' || application.status === 'failed') {
                <p-button size="small" (onClick)="deleteApplication(application.id)" label="Delete"
                          icon="pi pi-trash"></p-button>
              }
              @if (application.status === 'failed') {
                <p-button size="small" (onClick)="resyncApplication(application.id)" label="Resync"
                          icon="pi pi-refresh"></p-button>
                <p-button size="small" (onClick)="markApplicationAsNotSelected(application.id)" label="Fail"
                          icon="pi pi-send"></p-button>

              }
              @if (allowApplicationStatusEvent) {
                <p-button
                  size="small"
                  (onClick)="openStatusEventDialog(application)"
                  label="Emit status event"
                  icon="pi pi-bolt"></p-button>
              }
            </div>

          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7" class="text-center">No applications found</td>
        </tr>
      </ng-template>
    </p-table>
    <h2 class="mt-12 text-xl font-medium">Notification channels</h2>
    <div class="grid gap-4 mt-4 md:grid-cols-3">
      <div class="p-4 border surface-card rounded-md">
        <div class="flex justify-between items-center">
          <span class="font-semibold">Email channel</span>
          <p-tag
            [severity]="userValue.notificationChannels.email.enabled ? 'success' : 'danger'"
          >{{ userValue.notificationChannels.email.enabled ? 'Enabled' : 'Disabled' }}</p-tag>
        </div>
        <p class="text-sm mt-2 text-muted-color">
          Address: {{ userValue.notificationChannels.email.emailAddress || 'Not configured' }}
        </p>
      </div>
      <div class="p-4 border surface-card rounded-md">
        <div class="flex justify-between items-center">
          <span class="font-semibold">SMS channel</span>
          <p-tag
            [severity]="userValue.notificationChannels.text.enabled && !userValue.notificationChannels.text.optedOut ? 'success' : 'danger'"
          >{{ userValue.notificationChannels.text.enabled && !userValue.notificationChannels.text.optedOut ? 'Enabled' : 'Disabled' }}</p-tag>
        </div>
        <p class="text-sm mt-2 text-muted-color">
          Phone: {{ userValue.notificationChannels.text.phoneNr || 'Not configured' }}
        </p>
        <p class="text-sm text-muted-color">
          Opted out: {{ userValue.notificationChannels.text.optedOut ? 'Yes' : 'No' }}
        </p>
      </div>
      <div class="p-4 border surface-card rounded-md">
        <div class="flex justify-between items-center">
          <span class="font-semibold">Push channel</span>
          <p-tag
            [severity]="userValue.notificationChannels.push.enabled ? 'success' : 'danger'"
          >{{ userValue.notificationChannels.push.enabled ? 'Enabled' : 'Disabled' }}</p-tag>
        </div>
        <p class="text-sm mt-2 text-muted-color">
          Tokens: {{ userValue.notificationChannels.push.tokens.length }}
        </p>
      </div>
    </div>
  <h2 class="mt-12 text-xl font-medium">Notifications</h2>
  <p-table [value]="userValue.notifications">
    <ng-template pTemplate="header">
      <tr>
        <th>Type</th>
        <th>Created at</th>
        <th>Send status</th>
      </tr>
    </ng-template>
      <ng-template pTemplate="body" let-notification [cTypedTableRow]="userValue.notifications">
        <tr>
          <td>{{ notification.type }}</td>
          <td>{{ notification.createdAt | date: 'dd-MM-yyyy HH:mm:ss' }}</td>
          <td>{{ notification.readStatus }}</td>
          <td>
            <div class="flex flex-col gap-1">
              @for (status of notification.sendStatuses; track status) {
                <div class="text-sm">
                  {{ status.channel }}: {{ status.sendStatus }}
                  @if (status.failureReason) {
                    <span class="text-muted-color">
                      (failure: {{ status.failureReason }})
                    </span>
                  }
                  @if (status.notNeededReason) {
                    <span class="text-muted-color">
                      (not needed: {{ status.notNeededReason }})
                    </span>
                  }
                </div>
              }
              @if (!notification.sendStatuses.length) {
                <span class="text-muted-color">-</span>
              }
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4" class="text-center">No notifications found</td>
        </tr>
      </ng-template>
    </p-table>
    <h2 class="mt-12 text-xl font-medium">In-app notifications</h2>
    <p-table [value]="userValue.inAppNotifications">
      <ng-template pTemplate="header">
        <tr>
          <th>Type</th>
          <th>Status</th>
          <th>Created at</th>
          <th>Read at</th>
          <th>Data</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-notification [cTypedTableRow]="userValue.inAppNotifications">
        <tr>
          <td>{{ notification.type }}</td>
          <td>
            <p-tag [severity]="notification.status === 'read' ? 'success' : 'warn'">
              {{ notification.status }}
            </p-tag>
          </td>
          <td>{{ notification.createdAt | date: 'dd-MM-yyyy HH:mm:ss' }}</td>
          <td>{{ notification.readAt | date: 'dd-MM-yyyy HH:mm:ss' }}</td>
          <td><pre class="text-xs whitespace-pre-wrap">{{ notification.data | json }}</pre></td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5" class="text-center">No in-app notifications found</td>
        </tr>
      </ng-template>
    </p-table>
    <h2 class="mt-12 text-xl font-medium">Domain events</h2>
    <p-table [value]="userValue.domainEvents">
      <ng-template pTemplate="header">
        <tr>
          <th>ID</th>
          <th>Type</th>
          <th>Timestamp</th>
          <th>Payload</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-event [cTypedTableRow]="userValue.domainEvents">
        <tr>
          <td>{{ event.id }}</td>
          <td>{{ event.eventType }}</td>
          <td>{{ event.timestamp | date: 'dd-MM-yyyy HH:mm:ss' }}</td>
          <td>
            <pre class="text-xs whitespace-pre-wrap">{{ event.payload | json }}</pre>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4" class="text-center">No domain events found</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  @if (userValue.householdInfo) {
    <div class="p-8">
      <h2 class="text-2xl font-medium mb-4">Household</h2>
      <div class="flex flex-row gap-8 mb-6">
        <app-labeled label="Sync status"
                     [value]="userValue.householdInfo.nycData.syncStatus"
                     [tagFunction]="syncStatusToTag"></app-labeled>
        <p-button size="small"
                  (onClick)="onSync({type: 'household'})">Re-sync
        </p-button>
        @if (userValue.nycProfile?.status === 'complete') {
          <p-button size="small"
                    [loading]="verifyingHousehold()"
                    (onClick)="verifyHousehold()">Verify NYC household
          </p-button>
        }
        @if (userValue.householdInfo.nycData.syncStatus === 'sync-failed') {
          <p-button size="small"
                    (onClick)="reconnectHousehold()">Re-connect household id
          </p-button>
        }
      </div>
      <p>Id: {{ userValue.householdInfo.nycData.nycId }}</p>

      @if (householdVerificationResult(); as verification) {
        <div class="mt-4 border border-surface-200 rounded p-4">
          <div class="flex items-center gap-3 mb-2">
            <span class="font-medium">Last verification</span>
            <p-tag
              [severity]="verification.status === 'ok'
                ? (verification.issues.length === 0 && verification.householdComplete ? 'success' : 'warn')
                : 'danger'">
              {{ verification.status }}
            </p-tag>
            @if (verification.status === 'ok') {
              <span class="text-sm text-surface-500">Household id: {{ verification.householdId ?? 'none' }}</span>
            }
          </div>

          @if (verification.status === 'ok') {
            <p class="text-sm mb-2">Complete in NYC: {{ verification.householdComplete ? 'Yes' : 'No' }}</p>
            @if (verification.issues.length === 0) {
              <p class="text-sm text-green-700">No verification issues found.</p>
            } @else {
              <ul class="list-disc list-inside text-sm text-orange-700">
                @for (issue of verification.issues; track issue.code) {
                  <li>{{ issue.message }}</li>
                }
              </ul>
            }
          } @else {
            <p class="text-sm text-orange-700">{{ verification.reason }}</p>
          }
        </div>
      }

      @for (member of userValue.householdInfo.members; track member) {
        <app-household-member-details [householdMember]="member" (onSync)="onSync($event)"
                                      (onClearNycId)="onClearNycId($event)"></app-household-member-details>
      }

      <div class="mt-6">
        <h2 class="text-xl font-medium mb-4">Deleted members</h2>
        <div class="flex flex-row gap-8 mb-6">
          <app-labeled label="Sync status"
                       [value]="userValue.householdInfo.deletedMembers.syncStatus"
                       [tagFunction]="syncStatusToTag"></app-labeled>
          <p-button size="small" (onClick)="onSync({type: 'deleted-members'})">Re-sync</p-button>
        </div>
        @for (member of userValue.householdInfo.deletedMembers.nycIds; track member) {
          <p>{{ member }}</p>
        }

      </div>
    </div>
  }
}

<p-dialog header="Register in NYC" [modal]="true" [visible]="nycAuth() !== undefined"
          (visibleChange)="!nycAuth() || nycAuth.set(undefined)" [style]="{ width: '50rem' }">
  @if (nycAuth(); as nycAuth) {
    <div class="flex flex-row justify-between items-center mb-6">
    <span class="p-text-secondary block">
      NYC Profile Information
    </span>
    </div>
    <div class="flex items-center gap-4 mb-4">
      <div class="font-semibold w-24">Email 1</div>
      <div>{{ nycAuth.email1 }}</div>
    </div>
    <div class="flex items-center gap-4 mb-4">
      <div class="font-semibold w-24">Email 2</div>
      <div>{{ nycAuth.email2 }}</div>
    </div>
    <div class="flex items-center gap-4 mb-4">
      <div class="font-semibold w-24">Username</div>
      <div>{{ nycAuth.username }}</div>
    </div>
    <div class="flex items-center gap-4 mb-8">
      <div class="font-semibold w-24">Password</div>
      <div>{{ nycAuth.password }}</div>
    </div>
  }
</p-dialog>
<p-dialog
  header="Emit new-eligible-lottery event"
  [modal]="true"
  [visible]="eligibleEventDialogVisible()"
  (visibleChange)="eligibleEventDialogVisible.set($event)"
  [style]="{ width: '32rem' }">
  <p class="text-sm text-orange-600 mb-4">
    Test env only. Sends new-eligible-lottery event(s) for user {{ userId() }}.
  </p>

  <div class="flex flex-col gap-3">
    <div class="flex flex-wrap gap-2">
      @for (lottery of displayOpenLotteries(); track lottery.id) {
        <p-button
          [label]="lottery.name || lottery.id"
          size="small"
          [severity]="selectedLotteryIds().has(lottery.id) ? 'primary' : 'secondary'"
          (onClick)="toggleLotterySelection(lottery.id)"></p-button>
      }
    </div>

    <div class="flex flex-wrap gap-2 items-center">
      <p-button
        label="Random open lottery"
        icon="pi pi-refresh"
        size="small"
        severity="secondary"
        (onClick)="selectRandomOpenLottery()"></p-button>
      @if (selectedLotteryIds().size > 0) {
        <span class="text-sm text-muted-color">
          Selected: {{ selectedLotteryLabel() }}
        </span>
      }
    </div>
  </div>

  <div class="flex gap-2 justify-end mt-4">
    <p-button label="Cancel" severity="secondary" (onClick)="eligibleEventDialogVisible.set(false)"></p-button>
    <p-button label="Emit event" icon="pi pi-bolt" (onClick)="emitEligibleLotteryEvents()"></p-button>
  </div>
</p-dialog>
<p-dialog
  header="Emit application status event"
  [modal]="true"
  [visible]="statusEventDialogVisible()"
  (visibleChange)="statusEventDialogVisible.set($event)"
  [style]="{ width: '32rem' }">
  @if (selectedApplication(); as application) {
    <p class="text-sm text-orange-600 mb-4">
      Test env only. Sends an application-status-changed event for {{ application.id }} (lottery {{ application.lotteryId }}).
    </p>

    <div class="flex flex-col gap-3">
      <div class="flex flex-wrap gap-2">
        @for (status of statusOptions; track status) {
          <p-button
            [label]="status"
            [severity]="statusEventForm.controls.status.value === status ? 'primary' : 'secondary'"
            size="small"
            (onClick)="setStatus(status)"></p-button>
        }
      </div>

      @if (statusEventForm.controls.status.value === 'applied') {
        <div class="flex flex-col gap-2">
          <span class="text-sm font-semibold">Application method</span>
          <div class="flex flex-wrap gap-2">
            @for (method of applicationMethodOptions; track method) {
              <p-button
                [label]="method"
                size="small"
                [severity]="statusEventForm.controls.applicationMethod.value === method ? 'primary' : 'secondary'"
                (onClick)="setApplicationMethod(method)"></p-button>
            }
            <p-button
              label="Random"
              icon="pi pi-refresh"
              size="small"
              severity="secondary"
              (onClick)="setApplicationMethod(randomApplicationMethod())"></p-button>
          </div>
        </div>
      }

      @if (statusEventForm.controls.status.value === 'pending-selection' || statusEventForm.controls.status.value === 'not-selected') {
        <div class="flex flex-col gap-2">
          <span class="text-sm font-semibold">Lottery number</span>
          <div class="flex flex-wrap gap-2">
            <p-button
              label="Use log number"
              size="small"
              severity="secondary"
              (onClick)="setLotteryNumberFromLog(application)"></p-button>
            <p-button
              label="Random"
              size="small"
              icon="pi pi-refresh"
              severity="secondary"
              (onClick)="setLotteryNumberRandom()"></p-button>
            @if (statusEventForm.controls.lotteryNumber.value) {
              <span class="text-sm text-muted-color">
                Selected: {{ statusEventForm.controls.lotteryNumber.value }}
              </span>
            }
          </div>
        </div>
      }

      @if (statusEventForm.controls.status.value === 'not-selected') {
        <div class="flex flex-col gap-2">
          <span class="text-sm font-semibold">Reason</span>
          <div class="flex flex-wrap gap-2">
            @for (reason of reasonOptions; track reason) {
              <p-button
                [label]="reason"
                size="small"
                [severity]="statusEventForm.controls.reason.value === reason ? 'primary' : 'secondary'"
                (onClick)="setReason(reason)"></p-button>
            }
          </div>
        </div>
      }
    </div>

    <div class="flex gap-2 justify-end mt-4">
      <p-button label="Cancel" severity="secondary" (onClick)="statusEventDialogVisible.set(false)"></p-button>
      <p-button label="Emit event" icon="pi pi-bolt" (onClick)="emitStatusEvent()"></p-button>
    </div>
  }
</p-dialog>
<p-dialog header="Register in NYC" [modal]="true" [(visible)]="registerInNycVisible" [style]="{ width: '50rem' }">
  <div class="flex flex-row justify-between items-center mb-6">
    <span class="p-text-secondary block">
      NYC Profile Information
      <span>
        @if (editingNycProfile) {
          <span>(Save before submitting on NYC website)</span>
        }
      </span>
    </span>
    <p-button [icon]="'pi ' + (editingNycProfile ? 'pi-save' : 'pi-pencil') "
              (onClick)="onNycProfileEditToggle()"></p-button>
  </div>
  @if (nycProfileForm(); as form) {
    <div class="flex items-center gap-4 mb-8">
      <label for="username" class="font-semibold w-24">Username</label>
      <input pInputText
             id="username"
             class="flex-auto"
             autocomplete="off"
             [formControl]="form.controls.username"/>
      <app-copy-button [value]="form.controls.username.getRawValue()"/>
    </div>
    <div class="flex items-center gap-4 mb-8">
      <label for="password" class="font-semibold w-24">Password</label>
      <input pInputText
             id="password"
             class="flex-auto"
             autocomplete="off"
             [formControl]="form.controls.password"/>
      <app-copy-button [value]="form.controls.password.getRawValue()"/>
    </div>
    <div class="flex items-center gap-4 mb-8">
      <label for="firstName" class="font-semibold w-24">First name</label>
      <input pInputText
             id="firstName"
             class="flex-auto"
             autocomplete="off"
             [disabled]="true"
             [formControl]="form.controls.firstName"/>
      <app-copy-button [value]="form.controls.firstName.getRawValue()"/>
    </div>
    <div class="flex items-center gap-4 mb-8">
      <label for="lastName" class="font-semibold w-24">Last name</label>
      <input pInputText
             id="lastName"
             class="flex-auto"
             autocomplete="off"
             [disabled]="true"
             [formControl]="form.controls.lastName"/>
      <app-copy-button [value]="form.controls.lastName.getRawValue()"/>
    </div>
    <div class="flex items-center gap-4 mb-4">
      <label for="email1" class="font-semibold w-24">Email 1</label>
      <input
        pInputText
        id="email1"
        class="flex-auto"
        autocomplete="off"
        [formControl]="form.controls.email1"
      />
      <app-copy-button [value]="form.controls.email1.getRawValue()"/>
    </div>
    <div class="flex items-center gap-4 mb-8">
      <label for="email2" class="font-semibold w-24">Email 2</label>
      <input pInputText
             id="email2"
             class="flex-auto"
             autocomplete="off"
             [formControl]="form.controls.email2"/>
      <app-copy-button [value]="form.controls.email2.getRawValue()"/>
    </div>
    <div class="flex justify-end gap-2">
      <p-button [disabled]="editingNycProfile" label="Cancel" severity="secondary"
                (click)="registerInNycVisible.set(false)"/>
      <p-button [disabled]="editingNycProfile" label="Mark as registered" (click)="onMarkAsRegisteredClick()"/>
    </div>
  }
</p-dialog>
